import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultToggle } from "../../../../common/components/forms/inputs/toggle/DefaultToggle";
import { useReviewSettings } from "../hooks/useReviewSettings";
import { MIN_REVIEWS_TO_SHOW_LIMIT } from "../models/reviewSettingsFormModel";
import styles from "./ReviewSettingsDialog.module.scss";

interface IReviewSettingsDialogProps {
  visible: boolean;
  onHide: () => void;
}

/** "Ревюта → Настройки": e-mail invitations, the home-screen quote and the Google link. */
export const ReviewSettingsDialog = ({ visible, onHide }: IReviewSettingsDialogProps) => {
  const { form, isSaving, handleSubmit } = useReviewSettings(onHide);

  return (
    <AppDialog
      header="Настройки на ревютата"
      visible={visible}
      className={styles.dialog}
      onHide={onHide}
      dismissableMask={false}
    >
      <FormProvider {...form}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <section className={styles.form_section}>
            <h4 className={styles.form_section_title}>Покана по имейл</h4>
            <DefaultToggle
              name="reviewRequestsEnabled"
              label="Изпращай покана за ревю след посещение"
              width="100%"
            />
            <p className={styles.form_hint}>
              До няколко часа след посещение, отбелязано като „Дошъл“, клиентът получава имейл
              „Как беше?“. Клиент без ревю получава нова покана най-рано след 30 дни.
            </p>
          </section>

          <section className={styles.form_section}>
            <h4 className={styles.form_section_title}>Начален екран</h4>
            <DefaultToggle
              name="showReviewsPublicly"
              label="Показвай ревютата на началния екран"
              width="100%"
            />
            <DefaultInputField
              name="minReviewsToShow"
              label="Показвай ги след поне"
              placeholder="3"
              type="number"
              min={1}
              max={MIN_REVIEWS_TO_SHOW_LIMIT}
              step={1}
              tooltip="Цитатът под „Добре дошли!“ се появява едва когато има поне толкова видими ревюта."
              width="100%"
            />
          </section>

          <section className={styles.form_section}>
            <h4 className={styles.form_section_title}>Google</h4>
            <DefaultInputField
              name="googleReviewUrl"
              label="Линк към Google ревюта"
              placeholder="https://g.page/r/…/review"
              tooltip="След ревю по имейл клиентът вижда бутон да остави ревю и в Google. Без линк вижда само „Към началото“."
              width="100%"
            />
            <div className={styles.form_hint}>
              <p className={styles.form_hint_title}>Откъде да вземете линка</p>
              <ol className={styles.form_hint_steps}>
                <li>
                  Влезте в Google с акаунта, който управлява профила на студиото в Google
                  Maps (Google Business Profile).
                </li>
                <li>
                  Отворете{" "}
                  <a
                    href="https://business.google.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    business.google.com
                  </a>{" "}
                  или потърсете името на студиото в Google.
                </li>
                <li>
                  Натиснете бутона за събиране на отзиви („Ask for reviews“ / „Поискайте
                  отзиви“).
                </li>
                <li>Копирайте линка и го поставете тук. Започва с https://g.page/r/</li>
              </ol>
            </div>
          </section>

          <div className={styles.form_footer}>
            <DefaultButton label="Запази" type="submit" loading={isSaving} width="100%" />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
